/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from '@tanstack/react-query';
import { queryErrorHandler } from '../queryStateHandlers';
import { GET_LOGS_KEY } from '../queryConstants';
import { ILog } from '../../../@types/modelV2/logging/loggingModels';
import LogHttpService from '../../../services/http/logging/logHttpService';


export const useGetLogs = (fromDateUnix : number, toDateUnix : number) => {
    const query = useQuery<Array<ILog>, Error>({
        queryKey: [GET_LOGS_KEY],
        queryFn: ({ signal }) => LogHttpService.getList(fromDateUnix, toDateUnix, signal),
        onError: queryErrorHandler('Error loading Logs.'),
        refetchInterval: 10000,
    });

    return query;
};